import { SrOnlyText } from '../../Atoms/Text';
import { getOriginDescription, getOriginLabel } from '../../../utils/originLabel';

export type UpstackSourcedRendererProps = {
  origin: boolean;
  accountName?: string;
  converted?: boolean;
};

export function UpstackSourcedRenderer({ origin, accountName, converted = false }: UpstackSourcedRendererProps) {
  return (
    <div>
      {getOriginLabel(origin, converted, accountName)}
      <SrOnlyText>{getOriginDescription(origin, converted)}</SrOnlyText>
    </div>
  );
}
